/**
 * Smooth-scroll ke elemen dengan id tertentu (menyesuaikan tinggi navbar).
 * Memakai lenis jika aktif, fallback ke window.scrollTo.
 */
export function scrollToId(id, offset = 80) {
  const el = document.getElementById(id);
  if (!el) return;
  if (typeof window !== "undefined" && window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -offset, duration: 1.2 });
    return;
  }
  const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top, behavior: "smooth" });
}

export default scrollToId;
